<div class="row row--primary">
  <a class="link-secondary mb-2 cursor-pointer d-flex align-items-center" data-zid="multi-order-confirm-back" (click)="goBack.emit()">
    <svg class="icon icon-18 mr-1"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
    {{ 'trade.multi-order.confirm.back' | transloco }}
  </a>
</div>
<div class="row row--primary tile d-block" [zeroLoadingIndicator]="facade.sending$ | async">
  <div class="order-items-container">
    <div class="order-items-scroll">
      <trade-multi-order-confirm-orders />
    </div>
    <div class="order-items-wrapper"></div>
  </div>
  <trade-multi-order-summary class="d-block mb-4" />
  @if (facade.shouldDisplayEstimatedBuySum$ | async) {
    <trade-multi-order-estimated-sum direction="buy" class="d-block mb-4" />
  } @else if (facade.shouldDisplayEstimatedSellSum$ | async) {
    <trade-multi-order-estimated-sum direction="sell" class="d-block mb-4" />
  }
  <web-components-trading-session (authorizationState)="setTradingSessionState($event)" />
  <trade-multi-order-error [errors]="facade.multiOrderErrors$ | async" />
  <div class="row mt-4 mb-2">
    <div class="col">
      <web-design-system-button
        type="primary"
        data-zid="multi-order-confirm-btn"
        [disabled]="!hasTradingSession"
        [fullwidth]="true"
        (click)="facade.sendMultiOrder()"
      >
        @if (facade.multiOrderInstruments$ | async; as instruments) {
          @if (instruments.length > 1) {
            {{ 'trade.multi-order.confirm.submit.multiple' | transloco: { count: instruments.length } | uppercase }}
          } @else {
            {{ 'trade.multi-order.confirm.submit.single' | transloco | uppercase }}
          }
        }
      </web-design-system-button>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col text-center">
      <a class="link-secondary cursor-pointer" (click)="goBack.emit()">
        {{ 'trade.multi-order.confirm.cancel' | transloco }}
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h5>{{ 'trade.multi-order.confirm.hint-block.headline' | transloco }}</h5>
      <div class="hint">{{ 'trade.multi-order.confirm.hint-block.text' | transloco }}</div>
    </div>
  </div>
</div>
